module.exports = __webpack_public_path__ + "img/pic_6.8deec60d.png";